angular.module('invoice')
    .controller('InvoiceCostCenterDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, InvoiceCostCenter) {
        this.$onInit = () => {
            this.item = data
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = InvoiceCostCenter.update(this.item).$promise
            } else {
                promise = InvoiceCostCenter.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('invoice-cost-center.updated')
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        };
    })
